import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TalentPoolListEntity } from "app/services";

@Component({
  selector: "app-talent-pool-candidate-card",
  templateUrl: "./talent-pool-candidate-card.component.html",
  styleUrls: ["./talent-pool-candidate-card.component.scss"],
})
export class TalentPoolCandidateCard implements OnInit {
  @Input() candidate!: TalentPoolListEntity;
  @Input() isSelected!: boolean;

  @Output() openDetail: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  emitOpenDetail() {
    this.openDetail.emit(this.candidate);
  }

  get numberOfApplications(): number {
    return this.candidate.other_applications.length;
  }

  get numberOfCv(): number {
    const uniqueCvIds = new Set(
      this.candidate.other_applications
        .filter(cv => cv.curriculumId !== null)
        .map(cv => cv.curriculumId)
    );
    return uniqueCvIds.size;
  }
}
